// @flow

import GlobalTooltip from './GlobalTooltip';
import Tooltip from './Tooltip';
import tooltipReducer, { setTooltip } from './dux';
import withTooltip from './withTooltip';

export { GlobalTooltip, Tooltip, tooltipReducer, setTooltip, withTooltip };



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/Tooltip/index.js